// extracted by mini-css-extract-plugin
export default {"fileContainer":"Files_fileContainer__RZTOy"};